import React from "react";
import { ContentRedux } from "./Content";
import cname from "../style.module.scss";

import {
  FullscreenModal,
  CloseButton,
} from "@learningblocks/storybook-components/lib/FullscreenModal";

/**
 * Props for the PrincipleOfSpectrophotometerModal component
 */
interface MicroplateFocusModalProps {
  /**
   * Whether the modal window is open
   */
  isOpen: boolean;
  /**
   * Function to call when closing the modal window
   */
  onClose: () => void;
  /**
   * Whether the notebook is collapsed
   */
  notebookCollapsed: boolean;
  /**
   * size of  header
   */
  size: "sm" | "md" | "lg";
  /**
   * Whether the modal is open for dispensing liquid
   */
  isDispense: boolean;
}

/**
 * PrincipleOfSpectrophotometerModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function MicroplateFocusModal({
  isDispense = false,
  ...props
}: MicroplateFocusModalProps) {
  return (
    <FullscreenModal
      isOpen={props.isOpen}
      className={`${cname.microplateModal}`}
      notebookExpanded={!props.notebookCollapsed}
      close={props.onClose}
    >
      <div className={cname.backButton}>
        <CloseButton close={props.onClose} backLabel="Lab" />
      </div>
      <div className={cname.container}>
        <div className={cname.section}>
          <ContentRedux isDispense={isDispense} />
        </div>
      </div>
    </FullscreenModal>
  );
}
